import { useEffectWithController } from '@carvana/merch-react-hooks';
import { isFailure, isSuccess } from '@carvana/merch-result';
import { useContext, useRef } from 'react';
import { useIsLoggedIn } from '~/context/common/UserContext';
import RecentVehiclesContext from '~/context/home/RecentVehiclesContext';
import { fetchRecentVehicles } from '~/services/home';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function useGetRecentVehicles() {
  const {
    recentVehicles: { setData, setLoading, setError }
  } = useContext(RecentVehiclesContext);
  const isInitialRender = useRef(true);
  const isLoggedIn = useIsLoggedIn();

  useEffectWithController(
    controller => {
      if (isInitialRender.current) {
        isInitialRender.current = false;

        return;
      }

      setLoading();

      fetchRecentVehicles({ useAuth: isLoggedIn }, controller)
        .then(result => {
          if (isSuccess(result)) {
            setData(result.content);

            return;
          }

          if (isFailure(result)) {
            setError(new Error(result.errorMessage));
          }

          setData([]);
        })
        .catch(
          generateErrorLogger(
            'Get recent vehicles',
            {},
            { callback: setError, controller }
          )
        );
    },
    [isLoggedIn, setData, setError, setLoading]
  );
}
